// The pages a sync left as they were, grouped by why: edited here, written
// here, gone from the source, or refused. Every one of them is still in the
// space; the list is there so nobody has to wonder what a re-import skipped.
import { Link } from "react-router-dom"
import type { NotReimported } from "../lib/api"

const REASONS: Array<{ reason: NotReimported["reason"]; label: string }> = [
  { reason: "edited", label: "Edited in Moderniser — upstream not applied" },
  { reason: "written-here", label: "Written in Moderniser — not from the source" },
  { reason: "gone-upstream", label: "No longer returned by the source — kept" },
  { reason: "refused", label: "New upstream content refused — previous version kept" },
]

export function NotReimportedList({ pages, omitted = 0 }: { pages: NotReimported[] | undefined; omitted?: number }) {
  if (!pages?.length) return null
  return (
    <details className="text-sm">
      <summary className="cursor-pointer text-muted">
        Not re-imported ({pages.length + omitted}) — all kept in the space
      </summary>
      <div className="mt-2 flex flex-col gap-3">
        {REASONS.map(({ reason, label }) => {
          const list = pages.filter((p) => p.reason === reason)
          if (!list.length) return null
          return (
            <div key={reason} className="flex flex-col gap-1">
              <p className="text-xs font-medium text-foreground">
                {label} ({list.length})
              </p>
              <ul className="flex flex-col gap-0.5 pl-3">
                {list.map((p) => (
                  <li key={p.id}>
                    <Link to={`/context-hub/pages/${p.id}`} className="text-xs text-muted underline-offset-2 hover:text-foreground hover:underline">
                      {p.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )
        })}
        {omitted > 0 && <p className="text-xs text-muted">…and {omitted} more, not listed.</p>}
      </div>
    </details>
  )
}
